module.exports = __webpack_public_path__ + "src/assets/img/search.d3623ea2.png";